import { Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "./style.module.scss";

interface DonutChartSkeletonProps {
  size?: number;
  className?: string;
}

/** A circle of the exact donut footprint, so the ring swaps in without reflow. */
function DonutChartSkeleton({ size = 150, className }: DonutChartSkeletonProps) {
  return (
    <div
      className={classNames(styles.donut, className)}
      style={{ width: size, height: size, flexBasis: size }}
    >
      <Skeleton variant="circular" width="100%" height="100%" />
    </div>
  );
}

export default DonutChartSkeleton;
